export const employmentStatusSinceRulesOptions = {
  required: 'EmploymentStatusSince.error.required',
};
